import {charts} from 'common/util/colors';

const defaultColorPool = charts.funnelsChart.map((color) => color.primary);
const defaultOverallReservedColor = defaultColorPool[0];
export type ColorChoice = {key: string; color: string};

function* cycle(arr: string[]) {
  while (true) {
    for (const item of arr) {
      yield item;
    }
  }
}

function emptyFrequencyMap(keys: string[]): Map<string, number> {
  return new Map(keys.map((k) => [k, 0] as [string, number]));
}

/**
 * Pick less used colors for new items.
 *
 * Assumes that the difference in used color frequencies is <= 1.
 */
export function maybeAssignColors(
  lastState: ColorChoice[],
  newItems: string[],
  colorPool: string[] = defaultColorPool,
  overallReservedColor: string = defaultOverallReservedColor,
): ColorChoice[] {
  const usedColorMap = new Map(
    // In case of older bookmarks, filter out any segment that
    // used the overallReservedColor from having its colors carry over.
    lastState
      .filter((c) => newItems.includes(c.key) && c.color !== overallReservedColor)
      .map((c) => [c.key, c.color] as [string, string]),
  );

  const usedColorFrequency = emptyFrequencyMap(colorPool.filter((item) => item !== overallReservedColor));
  usedColorMap.forEach((value) => {
    usedColorFrequency.set(value, usedColorFrequency.get(value) + 1);
  });

  const sortedColors = [...usedColorFrequency.keys()].sort((aColor, bColor) => {
    return usedColorFrequency.get(aColor) - usedColorFrequency.get(bColor);
  });

  const colors = cycle(sortedColors);
  return newItems.map((item) => {
    // Overall always gets the same color, the other segments are cycled
    if (item === `$overall`) {
      return {color: overallReservedColor, key: item};
    }
    const existing = usedColorMap.get(item);
    if (existing) {
      return {color: existing, key: item};
    } else {
      return {color: colors.next().value as string, key: item};
    }
  });
}
